export const technologiesConst = [
   {
      id: 't-frontends',
      name: 'Front-End',
      items: [
         {
            name: 'Vue JS',
            image: '/assets/svg/technologies/vuejs.svg',
            alt: 'Vue Icon',
            href: '/technologies/frontend/vuejs-application-development-company',
         },
         {
            name: 'React JS',
            image: '/assets/svg/technologies/Vector.svg',
            alt: 'React Icon',
            href: '/technologies/frontend/react-development-company',
         },
         {
            name: 'Angular JS',
            image: '/assets/svg/technologies/angular.svg',
            alt: 'Angular Icon',
            href: '/technologies/frontend/angular-development-company',
         },
         {
            name: 'HTML5',
            image: '/assets/svg/technologies/html.svg',
            alt: 'HTML5 Icon',
         },
         {
            name: 'CSS3',
            image: '/assets/svg/technologies/css.svg',
            alt: 'CSS3 Icon',
         },
         {
            name: 'Next JS',
            image: '/assets/svg/technologies/next.svg',
            alt: 'Next.js Icon',
            href: '/technologies/frontend/next-js-application-development-company',
         },
         {
            name: 'Bootstrap',
            image: '/assets/svg/technologies/bootstrap.svg',
            alt: 'Bootstrap Icon',
         },
         {
            name: 'Three JS',
            image: '/assets/svg/technologies/threejs.svg',
            alt: 'Three JS Icon',
         },
         {
            name: 'jQuery',
            image: '/assets/svg/technologies/jquery.svg',
            alt: 'jQuery Icon',
         },
         {
            name: 'JavaScript',
            image: '/assets/svg/technologies/js.svg',
            alt: 'JavaScript Icon',
         },
         {
            name: 'TypeScript',
            image: '/assets/svg/technologies/ts.svg',
            alt: 'TypeScript Icon',
            href: '/technologies/frontend/typescript-development-company',
         },
      ],
   },
   {
      id: 't-backends',
      name: 'Back-End',
      items: [
         {
            name: 'PHP',
            image: '/assets/svg/technologies/php.svg',
            alt: 'PHP Icon',
            href: '/technologies/backend/php-application-development-company',
         },
         {
            name: 'Django',
            image: '/assets/svg/technologies/dj.svg',
            alt: 'Django Icon',
         },
         {
            name: 'Python',
            image: '/assets/svg/technologies/python.svg',
            alt: 'Python Icon',
            href: '/technologies/backend/python-development-company',
         },
         {
            name: 'Laravel',
            image: '/assets/svg/technologies/laravel.svg',
            alt: 'Laravel Icon',
            href: '/technologies/backend/laravel-application-development-company',
         },
         {
            name: 'Node JS',
            image: '/assets/svg/technologies/node.svg',
            alt: 'Node.js Icon',
            href: '/technologies/backend/nodejs-application-development-company',
         },
         {
            name: 'ASP.NET',
            image: '/assets/svg/technologies/asp.svg',
            alt: 'ASP.NET Icon',
            href: '/technologies/backend/aspdotnet-development-company',
         },
         {
            name: 'JAVA',
            image: '/assets/svg/technologies/java.svg',
            alt: 'Java Icon',
            href: '/technologies/backend/java-application-development-company',
         },
         {
            name: 'C++',
            image: '/assets/svg/technologies/c++.svg',
            alt: 'C++ Icon',
         },
         {
            name: 'CodeIgniter',
            image: '/assets/svg/technologies/codein.svg',
            alt: 'CodeIgniter Icon',
            href: '/technologies/backend/codeigniter-development-company',
         },
      ],
   },
   {
      id: 't-mobile',
      name: 'Mobile',
      items: [
         {
            name: 'IOS',
            image: '/assets/svg/technologies/ios.svg',
            alt: 'iOS Icon',
            href: '/technologies/mobile/ios-application-development-company',
         },
         {
            name: 'Android',
            image: '/assets/svg/technologies/android.svg',
            alt: 'Android Icon',
            href: '/technologies/mobile/android-application-development-company',
         },
         {
            name: 'Flutter',
            image: '/assets/svg/technologies/flutter.svg',
            alt: 'Flutter Icon',
            href: '/technologies/mobile/flutter-development-company',
         },
         {
            name: 'React Native',
            image: '/assets/svg/technologies/Vector.svg',
            alt: 'React Native Icon',
            href: '/technologies/mobile/react-native-development-company',
         },
         {
            name: 'Ionic',
            image: '/assets/svg/technologies/ionic.svg',
            alt: 'Ionic Icon',
         },
         {
            name: 'Swift',
            image: '/assets/svg/technologies/swift.svg',
            alt: 'Swift Icon',
         },
         {
            name: 'Kotlin',
            image: '/assets/svg/technologies/kotlin.svg',
            alt: 'Kotlin Icon',
         },
         {
            name: 'Objective C',
            image: '/assets/svg/technologies/objective.svg',
            alt: 'Objective C Icon',
         },
         {
            name: 'Titanium',
            image: '/assets/svg/technologies/titanium.svg',
            alt: 'Titanium Icon',
         },
      ],
   },
   {
      id: 't-uiux',
      name: 'UI/UX Design',
      items: [
         {
            name: 'Figma',
            image: '/assets/svg/technologies/figma.svg',
            alt: 'Figma Icon',
         },
         {
            name: 'Adobe XD',
            image: '/assets/svg/technologies/xd.svg',
            alt: 'Adobe XD Icon',
         },
         {
            name: 'Sketch',
            image: '/assets/svg/technologies/sketch.svg',
            alt: 'Sketch Icon',
         },
         {
            name: 'Adobe XD',
            image: '/assets/svg/technologies/Adobe.svg',
            alt: 'Adobe XD Icon',
         },
         {
            name: 'Adobe Illustrator',
            image: '/assets/svg/technologies/adobe_illustrator.svg',
            alt: 'Adobe Illustrator Icon',
         },
      ],
   },
   {
      id: 't-cms',
      name: 'CMS',
      items: [
         {
            name: 'Magento',
            image: '/assets/svg/technologies/Magento.svg',
            alt: 'Magento Icon',
         },
         {
            name: 'WordPress',
            image: '/assets/svg/technologies/WordPress.svg',
            alt: 'WordPress ICon',
         },
         {
            name: 'Shopify',
            image: '/assets/svg/technologies/shopify.svg',
            alt: 'Shopify Icon',
         },
         {
            name: 'Webflow',
            image: '/assets/svg/technologies/Webflow.svg',
            alt: 'Webflow ICon',
         },
         {
            name: 'Hubspot',
            image: '/assets/svg/technologies/hubspot.svg',
            alt: 'Hubspot Icon',
         },
         {
            name: 'Craft CMS',
            image: '/assets/svg/technologies/Craft-CMS.svg',
            alt: 'Craft CMS Icon',
         },
         {
            name: 'Joomla',
            image: '/assets/svg/technologies/joomla.svg',
            alt: 'Joomla Icon',
         },
         {
            name: 'Drupal',
            image: '/assets/svg/technologies/Drupal.svg',
            alt: 'Drupal Icon',
         },
         { name: 'Wix', image: '/assets/svg/technologies/wix.svg', alt: 'Wix' },
      ],
   },
   {
      id: 't-database',
      name: 'Database',
      items: [
         {
            name: 'MongoDB',
            image: '/assets/svg/technologies/mongo.svg',
            alt: 'MongoDB Icon',
         },
         {
            name: 'My SQL',
            image: '/assets/svg/technologies/mysql.svg',
            alt: 'MySQL Icon',
         },
         {
            name: 'Firebase',
            image: '/assets/svg/technologies/firebas.svg',
            alt: 'Firebase Icon',
         },
         {
            name: 'SQLite',
            image: '/assets/svg/technologies/SQLite.svg',
            alt: 'SQLite Icon',
         },
         {
            name: 'Realm',
            image: '/assets/svg/technologies/Realm.svg',
            alt: 'Realm Icon',
         },
         {
            name: 'PostgreSQL',
            image: '/assets/svg/technologies/PostgreSQL.svg',
            alt: 'PostgreSQL Icon',
         },
         {
            name: 'Redis',
            image: '/assets/svg/technologies/Redis.svg',
            alt: 'Redis Icon',
         },
         {
            name: 'MsSQL',
            image: '/assets/svg/technologies/MSSQL.svg',
            alt: 'MsSQL Icon',
         },
         {
            name: 'Hive',
            image: '/assets/svg/technologies/Hive.svg',
            alt: 'Hive Icon',
         },
         {
            name: 'Isar',
            image: '/assets/svg/technologies/Isar.svg',
            alt: 'Isar Icon',
         },
      ],
   },
   {
      id: 't-devops',
      name: 'Infra and DevOps',
      items: [
         { name: 'AWS', image: '/assets/svg/technologies/aws.svg', alt: 'AWS' },
         {
            name: 'Google Cloud',
            image: '/assets/svg/technologies/Google-Cloud.svg',
            alt: 'Google Cloud Icon',
         },
         {
            name: 'Gradle',
            image: '/assets/svg/technologies/Gradle.svg',
            alt: 'Gradle Icon',
         },
         {
            name: 'Jenkins',
            image: '/assets/svg/technologies/Jenkins.svg',
            alt: 'Jenkins Icon',
         },
         {
            name: 'Appium',
            image: '/assets/svg/technologies/Appium.svg',
            alt: 'Appium Icon',
         },
         {
            name: 'Selenium',
            image: '/assets/svg/technologies/Selenium.svg',
            alt: 'Selenium Icon',
         },
         {
            name: 'Docker',
            image: '/assets/svg/technologies/Docker.svg',
            alt: 'Docker Icon',
         },
         {
            name: 'Vercel',
            image: '/assets/svg/technologies/Vercel.svg',
            alt: 'Vercel Icon',
         },
         {
            name: 'Azure',
            image: '/assets/svg/technologies/Azure.svg',
            alt: 'Azure Icon',
         },
         {
            name: 'Digital Ocean',
            image: '/assets/svg/technologies/Digital_Ocean.svg',
            alt: 'Digital Ocea Icon',
         },
      ],
   },
   {
      id: 't-management',
      name: 'Project & Management',
      items: [
         {
            name: 'Microsoft Team',
            image: '/assets/svg/technologies/microsoft-teams.svg',
            alt: 'Microsoft Team Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Jira',
            image: '/assets/svg/technologies/Jira.svg',
            alt: 'Jira Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Asana',
            image: '/assets/svg/technologies/Asana.svg',
            alt: 'Asana Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Slack',
            image: '/assets/svg/technologies/Slack.svg',
            alt: 'Slack Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'ClickUp',
            image: '/assets/svg/technologies/ClickUp.svg',
            alt: 'ClickUp Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Trello',
            image: '/assets/svg/technologies/Trello.svg',
            alt: 'Trello Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Monday.com',
            image: '/assets/svg/technologies/Monday.com.svg',
            alt: 'Monday.com Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Github',
            image: '/assets/svg/technologies/Github.svg',
            alt: 'Github Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Gitlab',
            image: '/assets/svg/technologies/Gitlab.svg',
            alt: 'Gitlab Icon',
            href: '/technologies/project-management',
         },
         {
            name: 'Bitbucket',
            image: '/assets/svg/technologies/Bitbucket.svg',
            alt: 'Bitbucket Icon',
            href: '/technologies/project-management',
         },
      ],
   },
]
